<template>
  <div class="level">
    <div class="level-item">
      <div class="block has-text-centered">

        <!-- logo -->
        <img id="logo" class="image" src="@/assets/images/fend-logo.png">

        <!-- subtitle -->
        <div class="my-5">Enter a new password.</div>

        <form v-on:submit.prevent="submit" novalidate>

          <!-- password -->
          <div class="field">
            <div class="control">
              <input class="input" :class="{'is-danger': (errors.password || errors.code)}"
                     type="password" placeholder="Password" v-model="password">
            </div>
          </div>

          <p v-show="errors.password" class="help is-danger pb-3">
            Please enter a password that is at least 8 characters long and contains numbers, lowercase letters
            and uppercase letters.
          </p>

          <p v-show="errors.code == 'invalid'" class="help is-danger pb-3">
            Your reset password code is invalid
          </p>

          <p v-show="errors.code == 'too_many_attempts'" class="help is-danger pb-3">
            You've attempted to change your password too many times. Your ability to request a password reset has been
            temporarily restricted. Please try again later or contact support@fend.tech for assistance.
          </p>

          <!-- submit -->
          <div class="control">
            <button class="button is-fullwidth is-primary">Save</button>
          </div>

          <!-- login -->
          <div class="pt-4 is-size-6">
            <router-link class="has-text-primary" to="/login">Back to Login</router-link>
          </div>
        </form>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'confirm',
  data() {
    return {
      password: '',
      errors: {}
    };
  },
  methods: {
    async submit() {
      try {
        const user = this.$route.query.user;
        const code = this.$route.query.code;
        await api.auth.confirm(user, code, this.password);
        this.error = '';
        this.$router.push('/login');
      } catch (error) {
        this.errors = error.data || {};
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #logo {
    max-width: 175px;
  }
  .level {
    flex-grow: 1;
    min-width:0; min-height:0;
  }
  .block {
    max-width: 400px;
  }
</style>
